export const BILL_ITEMS = [
  "data",
  "electricity",
  "airtime",
  "cable",
  "insurance",
  "education",
];

export const VTU_PENDING_PAYMENT_KEY = "vtuPendingPayment";

export const INITIAL_FORM_VALUES = {
  electricity: {
    meterNumber: "",
    serviceProvider: "",
    type: "",
    amount: "",
  },
  airtime: {
    phoneNumber: "",
    network: "",
    amount: "",
  },
  data: {
    phoneNumber: "",
    network: "",
    dataPlan: "",
  },
  cable: {
    cableTv: "",
    decoderNumber: "",
    cablePlan: "",
  },
  insurance: {
    insurancePlan: "",
    phone: "",
    email: "",
    insuredName: "",
    plateNumber: "",
    chassisNumber: "",
    vehicleMake: "",
    vehicleModel: "",
    vehicleColor: "",
    engineCapacity: "",
    yearOfMake: "",
    state: "",
    lga: "",
  },
  education: {
    educationService: "",
    plan: "",
    phone: "",
    quantity: "1",
    billersCode: "",
  },
};

export const PAYLOAD_LABELS = {
  electricity: {
    meterNumber: "Meter Number",
    serviceProvider: "Service Provider",
    type: "Type",
    amount: "Amount",
  },
  airtime: {
    phoneNumber: "Phone Number",
    network: "Network",
    amount: "Amount",
  },
  data: {
    phoneNumber: "Phone Number",
    network: "Network",
    dataPlan: "Data Plan",
  },
  cable: {
    cableTv: "Cable TV",
    decoderNumber: "Decoder Number",
    cablePlan: "Cable Plan",
  },
  insurance: {
    insurancePlan: "Insurance Plan",
    phone: "Phone Number",
    email: "Email",
    insuredName: "Insured Name",
    plateNumber: "Plate Number",
    chassisNumber: "Chassis Number",
    vehicleMake: "Vehicle Make",
    vehicleModel: "Vehicle Model",
    vehicleColor: "Vehicle Color",
    engineCapacity: "Engine Capacity",
    yearOfMake: "Year of Make",
    state: "State",
    lga: "LGA",
  },
  education: {
    educationService: "Service",
    plan: "Plan",
    phone: "Phone Number",
    quantity: "Quantity",
    billersCode: "Profile ID",
    jambProfileName: "Verified Name",
  },
};

export const NETWORK_SERVICE_ID = {
  mtn: "mtn",
  airtel: "airtel",
  glo: "glo",
  "9mobile": "etisalat",
};
